import script from "./AllOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./AllOrders.vue?vue&type=script&setup=true&lang=js"

import "./AllOrders.vue?vue&type=style&index=0&id=de9973da&lang=css"

const __exports__ = script;

export default __exports__